import { render } from "./ClickBankProducts.vue?vue&type=template&id=51659732"
import script from "./ClickBankProducts.vue?vue&type=script&lang=js"
export * from "./ClickBankProducts.vue?vue&type=script&lang=js"
script.render = render

export default script